import React from 'react';
import _ from 'lodash';

import WorkerImageApi from '../../../services/workers/workerImage/WorkerImageApi';
import WorkerImageService from '../../../services/workers/workerImage/WorkerImageService';
import SessionStorageService from '../../../services/utilities/SessionStorageService';

import { WorkerHeader } from '../header/WorkerHeader';
import { WorkerImageForm } from '../form/WorkerImageForm';
import Information from '../../modals/common/Information';
import Confirmation from '../../modals/common/Confirmation';

import masterSlideLoader from '../../../utilities/masterSlideLoader';
import { messageUtility } from '../../../utilities/messageUtility';
import { extractErrorMessage } from '../../../utilities/commonUtil';
import { isNullOrUndefinedOrEmptyStr } from '../../../utilities/stringUtil';
import { isTargetRoleId } from '../../../utilities/roleUtility';
import {
  WORKER_TAB,
  WORKER_PAGE_STATUS,
  DIALOG_STATUS,
  FACE_PICTURE_UPLOAD_STATUS,
  USER_ROLES,
} from '../../../utilities/constants';

/**
 * 作業員顔写真ページ
 * @props {object}pageStatus:ページ情報 (詳細・編集)
 * @props {string}workerId:作業員ID
 * @props {string}companyId:会社ID
 */
export class WorkerImage extends React.Component {
  state = {
    header: {
      // 作業員基本情報ヘッダー用プロパティ
      LinkButtonObject: {}, // 作業員一覧ページに戻るリンク (内容はbuttonObject)
      buttonObject: {}, // ボタン内容 (内容はbuttonObject)
    },
    headerButtonObject: {
      // ヘッダーで必要なモデル (詳細はWorkerHeader.jsxを参照)
      label: data.defaultButton.label, // テキスト
      className: data.defaultButton.className, // クラス名
      onClick: null, // 処理
    },
    workerImage: {
      imageUrl: '',
      imageBinary: null,
      imageName: '',
      uploadStatus: FACE_PICTURE_UPLOAD_STATUS.notChangedFile.id,
    },
    dialogStatus: DIALOG_STATUS.disabled.id, // ダイアログ表示用ステータス
    informationModal: {
      // インフォメーションモーダル用プロパティ (ボタン1つ)
      message: null, // モーダルダイアログのメッセージ
    },
    roanToChoseiFlg: false, // 労安からの遷移先が直接「作業員詳細」か、黒メニュー「作業員一覧」経由かを区別するフラグ
  };

  events = {};

  constructor(props) {
    super(props);

    this.updatingFlag = true; // 多重更新防止Flag

    if (
      !(
        props.pageStatus === WORKER_PAGE_STATUS.CONFIRM ||
        props.pageStatus === WORKER_PAGE_STATUS.EDIT
      )
    ) {
      throw new Error('WorkerImage.jsx constructor props.pageStatus');
    }
    if (_.isUndefined(props.workerId)) {
      throw new Error('WorkerImage.jsx constructor props.workerId');
    }
    if (_.isUndefined(props.companyId)) {
      throw new Error('WorkerImage.jsx constructor props.companyId');
    }

    // WorkerImage.jsxに渡すイベント
    this.events.setValueWorkerImage = this.setValueWorkerImage.bind(this);
    this.state.roanToChoseiFlg = props.roanToChoseiFlg;

    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createConfirmPageHeaderButton(this.state);
        break;
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createEditPageHeaderButton(this.state);
        break;
      default:
        break;
    }
  }

  /**
   * React Component LifeCycle
   * マウントが行われた直後
   * */
  async componentDidMount() {
    let state = { ...this.state };

    await WorkerImageApi.fetchFacePicture(
      this.props.workerId,
      Object.create(null)
    ).then(response => {
      if (response.result) {
        if (response.data.total > 0) {
          state.workerImage.imageUrl = response.data.entities.image_url;
        }
      }
    });

    this.setState(state, () => {
      this.updatingFlag = false; // 画面ロード後更新可能になる
    });
  }

  /**
   * =====================================================
   * ヘッダー周りの処理 - START
   * =====================================================
   */

  /**
   * buttonObjectを初期化する
   * @param {object} state: ステート
   * */
  clearButtonObject = state => {
    state.headerButtonObject.label = data.defaultButton.label;
    state.headerButtonObject.className = data.defaultButton.className;
    state.headerButtonObject.onClick = null;
    return state;
  };

  /**
   * 作業員一覧ページに戻るためのリンクを作成する
   * @param {object} state: ステート
   * */
  createObjectForMoveToWorkerList = state => {
    state.headerButtonObject.label = data.buttonLink.label;
    state.headerButtonObject.className = data.buttonLink.defaultClassName;
    state.headerButtonObject.onClick = this.handlerMoveToWorkerList.bind(this);
    state.header.LinkButtonObject.moveToWorkerList = _.cloneDeep(
      state.headerButtonObject
    );
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 詳細画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createConfirmPageHeaderButton = state => {
    if (isTargetRoleId([USER_ROLES.partner])) {
      // 編集ボタン作成
      state.headerButtonObject.label = data.header.confirm.button.edit.label;
      state.headerButtonObject.className =
        data.header.confirm.button.edit.className;
      state.headerButtonObject.onClick = this.moveToWorkerEdit.bind(this);
      state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    }
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 編集画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createEditPageHeaderButton = state => {
    // 編集をやめるボタン作成
    state.headerButtonObject.label = data.header.edit.button.cancel.label;
    state.headerButtonObject.className =
      data.header.edit.button.cancel.className;
    state.headerButtonObject.onClick = this.showCancelEditDialog.bind(this);
    state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);

    // 更新ボタン作成
    state.headerButtonObject.label = data.header.edit.button.update.label;
    state.headerButtonObject.className =
      data.header.edit.button.update.className;
    state.headerButtonObject.onClick = this.updateWorkerImage.bind(this);
    state.header.buttonObject.register = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 作業員一覧へ戻るリンクをクリックした時の処理
   * */
  handlerMoveToWorkerList = () => {
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.showLeaveThisPageDialog();
        break;
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.moveToWorkerList();
        break;
      default:
        break;
    }
  };

  /**
   * =====================================================
   * ヘッダー周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * 画面遷移周りの処理 - START
   * =====================================================
   */

  /**
   * 作業員一覧画面に遷移する
   */
  moveToWorkerList = () => {
    masterSlideLoader.show('Workers', { state: {} });
  };

  /**
   * 顔写真詳細画面に遷移する
   */
  moveToWorkerConfirm = () => {
    if (this.state.roanToChoseiFlg) {
      SessionStorageService.setRoanToChoseiFlg(this.state.roanToChoseiFlg);
    }
    masterSlideLoader.show('WorkerConfirm', {
      state: {
        id: `${WORKER_TAB.WORKER_IMAGE.TAB_NAME},${this.props.workerId}`,
      },
    });
  };

  /**
   * 顔写真編集画面に遷移する
   */
  moveToWorkerEdit = () => {
    if (this.state.roanToChoseiFlg) {
      SessionStorageService.setRoanToChoseiFlg(this.state.roanToChoseiFlg);
    }
    masterSlideLoader.show('WorkerEdit', {
      state: {
        id: `${WORKER_TAB.WORKER_IMAGE.TAB_NAME},${this.props.workerId}`,
      },
    });
  };

  /**
   * =====================================================
   * 画面遷移周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * ダイアログ周りの処理 - START
   * =====================================================
   */

  /**
   * ダイアログを閉じる
   * */
  closeDialog = () => {
    let state = { ...this.state };
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.informationModal.message = null;
    this.setState(state);
  };

  /**
   * 編集をやめるダイアログを表示する
   * */
  showCancelEditDialog = () => {
    let state = { ...this.state };
    state.dialogStatus = DIALOG_STATUS.cancelEditDialogEnabled.id;
    this.setState(state);
  };

  /**
   * ページを移動する旨を示すダイアログを表示する
   * */
  showLeaveThisPageDialog = () => {
    let state = { ...this.state };
    state.dialogStatus = DIALOG_STATUS.leaveThisPageDialogEnabled.id;
    this.setState(state);
  };

  /**
   * =====================================================
   * ダイアログ周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * API周りの処理 - START
   * =====================================================
   */

  /**
   * 作業員顔写真登録・更新
   */
  updateWorkerImage() {
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    const state = { ...this.state };
    const formData = WorkerImageService.createUpdateWorkerFacePicture(
      Object.assign(state.workerImage, {
        workerId: this.props.workerId,
      })
    );
    WorkerImageApi.updateFacePicture(formData)
      .then(response => {
        if (response.result === true) {
          this.updatingFlag = false;
          this.moveToWorkerConfirm();
          return;
        }

        state.dialogStatus = DIALOG_STATUS.updateFailedDialogEnabled.id;
        state.informationModal.message = extractErrorMessage(response);
        this.updatingFlag = false;
        this.setState(state);
      })
      .catch(error => {
        state.dialogStatus = DIALOG_STATUS.updateFailedDialogEnabled.id;
        state.informationModal.message = extractErrorMessage(error);
        this.updatingFlag = false;
        this.setState(state);
      });
  }

  /**
   * =====================================================
   * API周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   *フォーム周りの処理 - START
   * =====================================================
   */

  /**
   * 顔写真情報をセット
   */
  setValueWorkerImage(value) {
    if (isNullOrUndefinedOrEmptyStr(value) === false) {
      const state = _.cloneDeep(this.state);
      if (value.imageUrl !== null) {
        state.workerImage.imageUrl = value.imageUrl;
      }
      if (value.imageBinary !== null) {
        state.workerImage.imageBinary = value.imageBinary;
      }
      if (value.imageName !== null) {
        state.workerImage.imageName = value.imageName;
      }
      state.workerImage.uploadStatus = value.uploadStatus;
      this.setState(state);
    }
  }

  /**
   * =====================================================
   * フォーム周りの処理 - END
   * =====================================================
   */

  // 画面表示
  render() {
    return (
      <React.Fragment>
        <WorkerHeader
          LinkButtonObject={this.state.header.LinkButtonObject}
          buttonObject={this.state.header.buttonObject}
          errorMessagesCount={0}
        />
        <div className='contruction-detail-view__bar' />
        <WorkerImageForm
          events={this.events}
          workerImage={this.state.workerImage}
          showEditButton={
            this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID
          }
          showDeleteButton={
            this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID
          }
        />

        {/* 更新失敗時のダイアログ */}
        <Information
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.updateFailedDialogEnabled.id
          }
          title={messageUtility.getMessage('E-000-005')}
          message={this.state.informationModal.message}
          buttonText={messageUtility.getMessage('I-000-008')}
          onClose={() => this.closeDialog()}
        />

        {/* 編集をやめる時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus === DIALOG_STATUS.cancelEditDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-025')}
          confirmButtonText={messageUtility.getMessage('I-000-025')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-050')}
          isNegative
          onConfirm={() => this.moveToWorkerConfirm()}
          onCancel={() => this.closeDialog()}
        />

        {/* 作業員一覧へ戻る時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.leaveThisPageDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-051')}
          confirmButtonText={messageUtility.getMessage('I-000-053')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-052')}
          isNegative
          onConfirm={() => this.moveToWorkerList()}
          onCancel={() => this.closeDialog()}
        />
      </React.Fragment>
    );
  }
}

// 定数
const data = {
  buttonLink: {
    label: '作業員一覧',
    defaultClassName: 'btn-text--sm',
  },
  defaultButton: {
    label: '',
    className: 'btn',
  },
  header: {
    confirm: {
      button: {
        edit: {
          label: '編集',
          className: 'btn',
        },
      },
    },
    edit: {
      button: {
        cancel: {
          label: '編集をやめる',
          className: 'btn--sub',
        },
        update: {
          label: '更新',
          className: 'btn--effective',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/worker/page/WorkerImage.jsx